import mobileApi from '../../mystaff/mobileApi'

export async function OpenShiftLoader ({ params }) {
  // skip, take
  const searchParams = new URLSearchParams(params)
  const messages = await mobileApi.getOpenAndSuggestedShifts(searchParams)
  return messages
}
